(function(){
const COLORS={
"Black / Red":["#202125","#c72732"],"Black/Red":["#202125","#c72732"],
"Black / Heather Grey":["#202125","#a5a5a5"],"Black/Heather Grey":["#202125","#a5a5a5"],
"Charcoal / Heather Grey":["#4b4b50","#b1b1b1"],"Charcoal/Heather Grey":["#4b4b50","#b1b1b1"],
"Fuchsia / Heather Grey":["#d22c78","#b5b4b5"],"Fuchsia/Heather Grey":["#d22c78","#b5b4b5"],
"Heather Grey / Navy":["#bcbaba","#252f4d"],"Heather Grey/Navy":["#bcbaba","#252f4d"],
"Lime / Purple":["#a4d32a","#573674"],"Lime/Purple":["#a4d32a","#573674"],
"Navy / Heather Grey":["#28354f","#b5b5b5"],"Navy/Heather Grey":["#28354f","#b5b5b5"],
"Navy / Sky":["#28354f","#84c3e5"],"Navy/Sky":["#28354f","#84c3e5"],
"Purple / Yellow":["#563a81","#edcf40"],"Purple/Yellow":["#563a81","#edcf40"],
"Royal / Navy":["#2958aa","#24344d"],"Royal/Navy":["#2958aa","#24344d"],
"Sapphire / Heather Grey":["#168cb9","#b5b5b5"],"Sapphire/Heather Grey":["#168cb9","#b5b5b5"],
"White / Fuchsia":["#f6f4f4","#d73781"],"White/Fuchsia":["#f6f4f4","#d73781"],
"Bottle Green":["#234b35","#234b35"],"Black":["#202125","#202125"],"Charcoal":["#4a4b4f","#4a4b4f"],"Heather Grey":["#bcbaba","#bcbaba"],"Hot Pink":["#e63689","#e63689"],"Jade":["#1b9997","#1b9997"],"Kelly Green":["#2b9b45","#2b9b45"],"Military Green":["#526144","#526144"],"Maroon":["#632b3a","#632b3a"],"Navy":["#253652","#253652"],"Olive":["#667044","#667044"],"Orange":["#e67825","#e67825"],"Pink":["#de79a3","#de79a3"],"Purple":["#603a82","#603a82"],"Red":["#c83035","#c83035"],"Royal":["#2860bc","#2860bc"],"Sky":["#86c6e9","#86c6e9"],"Sapphire Blue":["#178fba","#178fba"],"Violet":["#8451ac","#8451ac"],"White":["#f5f4f4","#f5f4f4"],"Yellow":["#efcf43","#efcf43"]
};
function norm(s){return String(s||"").toLowerCase().replace(/\s*\/\s*/g,"/").trim();}
function boot(root){
 if(root.dataset.peReady)return;root.dataset.peReady="1";
 const form=root.closest('form[action*="/cart/add"]');
 const section=root.closest('[id^="MainProduct-"]')||document;
 const photo=root.querySelector('[data-pe-front-photo]');
 const photoMissing=root.querySelector('[data-pe-no-photo]');
 const backImage=root.querySelector('[data-pe-uploaded-back]');
 const badge=root.querySelector('[data-pe-user-badge]');
 const badgeSvg=root.querySelector('[data-pe-sample-badge]');
 const later=root.querySelector('[data-pe-send-later]');
 const error=root.querySelector('[data-pe-errors]');
 const uploads=Array.from(root.querySelectorAll('[data-pe-artwork]'));
 let links=[]; let previousFileUris={};
 let photoMap={};try{photoMap=JSON.parse(root.querySelector('[data-pe-photo-map]').textContent)}catch(e){}
 const colorLabels=Array.from(root.querySelectorAll('[data-pe-choice]'));
 const optionValue=(name)=>{
   const variants=Array.from(section.querySelectorAll('variant-radios,variant-selects'));
   for(const picker of variants){const elements=Array.from(picker.querySelectorAll('fieldset,select'));
     for(const el of elements){
       if(el.matches('fieldset')){const title=el.querySelector('legend');if(title&&title.textContent.trim().toLowerCase()===name.toLowerCase()){const checked=el.querySelector('input:checked');if(checked)return checked.value;}}
       else if(el.name&&el.name.toLowerCase()==='options['+name.toLowerCase()+']')return el.value;
     }
   }
   return null;
 };
 const pickColour=(name)=>{
  const radios=Array.from(section.querySelectorAll('variant-radios input[type="radio"]')).filter(x=>x.name.toLowerCase()==="colour");
  const radio=radios.find(x=>norm(x.value)===norm(name));
  if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));return;}
  const select=Array.from(section.querySelectorAll('variant-selects select')).find(x=>x.name.toLowerCase()==="options[colour]");
  if(select){select.value=name;select.dispatchEvent(new Event('change',{bubbles:true}));}
 };
 const update=(color)=>{
  const entry=Object.entries(photoMap).find(k=>norm(k[0])===norm(color));
  if(entry){if(entry[1]){photo.src=entry[1];photo.hidden=false;photoMissing.hidden=true;}else{photo.hidden=true;photoMissing.hidden=false;}}
  root.querySelector('[data-pe-colour-label]').textContent=color;
  const scheme=Object.entries(COLORS).find(x=>norm(x[0])===norm(color));
  if(scheme){root.style.setProperty('--pe-body',scheme[1][0]);root.style.setProperty('--pe-accent',scheme[1][1]);const light=["white","heather grey","lime","yellow","sky","pink"].some(x=>norm(color).startsWith(x));root.style.setProperty('--pe-letter',light?"#232229":"#fff");root.style.setProperty('--pe-seam',light?"#8b8b90":"#141821");}
  colorLabels.forEach(b=>b.setAttribute('aria-pressed',String(norm(b.dataset.peChoice)===norm(color))));
 };
 colorLabels.forEach(b=>b.addEventListener('click',()=>{pickColour(b.dataset.peChoice);update(b.dataset.peChoice);}));
 section.addEventListener('change',e=>{if(e.target.closest('variant-radios, variant-selects')){const value=optionValue('Colour');if(value)update(value);}});
 update(optionValue('Colour')||root.dataset.defaultColour);
 function updateFile(input){
  const kind=input.dataset.peArtwork;
  const f=input.files&&input.files[0];
  const label=root.querySelector('[data-pe-filename="'+kind+'"]');
  if(label)label.textContent=f?f.name:'Choose artwork';
  error.hidden=true;
  if(f && f.type.startsWith('image/')){
   if(previousFileUris[kind])URL.revokeObjectURL(previousFileUris[kind]);
   const next=URL.createObjectURL(f);previousFileUris[kind]=next;links.push(next);
   if(kind==='front'){badge.src=next;badge.hidden=false;badgeSvg.style.display='none';}
   else{backImage.setAttribute('href',next);backImage.style.display='block';}
  }else if(!f){
   if(kind==='front'){badge.removeAttribute('src');badge.hidden=true;badgeSvg.style.display='block';}
   else{backImage.removeAttribute('href');backImage.style.display='none';}
  }
 }
 uploads.forEach(x=>x.addEventListener('change',()=>updateFile(x)));
 if(form){
   form.enctype='multipart/form-data';
   form.method='post';
   form.removeAttribute('novalidate');
   form.addEventListener('invalid',function(){error.textContent='Please upload both artwork files or choose to email them after checkout.';error.hidden=false;},true);
   // Native Shopify multipart POST, not Dawn's Ajax add-to-cart, is required for file line-item properties.
   form.addEventListener('submit',function(ev){
     ev.stopImmediatePropagation();
     if(later && later.checked){uploads.forEach(x=>x.required=false);}
     else{uploads.forEach(x=>x.required=true);}
     const tooLarge=uploads.find(x=>x.files&&x.files[0]&&x.files[0].size>10*1024*1024);
     if(tooLarge){ev.preventDefault();error.textContent='Artwork files must be 10 MB or smaller. Please choose a smaller file.';error.hidden=false;tooLarge.focus();return;}
     if(!(later&&later.checked)&&uploads.some(x=>!x.files||!x.files.length)){
       ev.preventDefault();error.textContent='Please upload both artwork files, or tick the option to email artwork after checkout.';error.hidden=false;uploads.find(x=>!x.files||!x.files.length).focus();return;
     }
     // Allow browser native submit to /cart/add with multipart/form-data.
   },true);
 }
 if(later){later.addEventListener('change',()=>{uploads.forEach(x=>x.required=!later.checked);error.hidden=true;});}
 uploads.forEach(x=>x.required=!(later&&later.checked));
 window.addEventListener('pagehide',()=>links.forEach(x=>URL.revokeObjectURL(x)),{once:true});
}
function init(){document.querySelectorAll('[data-pe-leavers]').forEach(boot);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();